import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AccountantTransferProcess } from '@/types'

export const getCompanyAccountantTransferProcess = async (
  companyKey: string,
) => {
  const response = await httpClient('accounting-dealer').get<AccountantTransferProcess>(
    `/v3/company/${companyKey}/accountant-transfer-process`,
    {
      ignoreErrorToast: true,
    },
  )
  return response.data
}

export const useGetCompanyAccountantTransferProcess = (
  companyKey: string,
  options?: Partial<
    UseQueryOptions<
      AccountantTransferProcess,
      Error,
      AccountantTransferProcess
    >
  >,
) => {
  return useQuery({
    queryKey: ['company-accountant-transfer-process', companyKey],
    queryFn: () => getCompanyAccountantTransferProcess(companyKey),
    staleTime: 0,
    ...options,
  })
}
